import { trackLinkClick } from "@/utils/adobeAnalytics";
import Link from "../Link";

interface SignpostProps {
  text: string;
  buttonText: string;
  href: string;
}

const Signpost = ({ text, buttonText, href }: SignpostProps) => {
  return (
    <>
      <div className="lc-p-6 lc-w-full lc-bg-cfa-blue-975 lc-justify-center md:lc-justify-between lc-items-center lc-inline-flex lc-mt-8 lc-flex-wrap lc-gap-6 lc-z-[1]">
        <p className="lc-text-white lc-text-lg lc-font-azo-sans">{text}</p>
        <Link
          text={buttonText}
          onClick={() => trackLinkClick(buttonText, href)}
          size="sm"
          type="tertiary"
          href={href}
          target="_self"
        />
      </div>
    </>
  );
};

export default Signpost;
